import { render, staticRenderFns } from "./TotalIncome.vue?vue&type=template&id=e5ca3678&"
import script from "./TotalIncome.vue?vue&type=script&lang=js&"
export * from "./TotalIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports